<app-shared-drawer [isOpen]="true" [title]="drawerTitle" (onClose)="handleClose()"
  className="drawer-feedback-form-drawer" contentClassName="drawer-feedback-form-content">
  <div class="px-2 py-0 gap-4 d-flex align-items-center justify-content-start mb-2" *ngIf="mode === FeedbackFormMode.Create">
    <div class="mt-0 d-flex flex-column">
      <span>Colaborador</span>
      <div class="mt-1 d-flex gap-3 align-items-center">
        <img alt="avatar" class="avatar" [width]="36" [height]="36"
          [src]="currentEmployee?.shortProfileImagePath || 'assets/images/logo/avatar-profile.png'" />
        <div class="d-flex flex-column">
          <span class="font-weight-bolder">{{ currentEmployee?.name }}</span>
          <div>
            <span class="text-xs">MAT: {{ currentEmployee?.registration }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <form *ngIf="mode === FeedbackFormMode.Create" class="form-horizontal px-2 py-2" [formGroup]="form" (ngSubmit)="handleSave()">
    <div class="row">
      <div class="col-md-12 mb-2 px-2">
        <label class="form-control-label" for="keepDoing">Continuar fazendo</label>
        <div class="textarea-wrapper" [class.is-checking]="checkingField.keepDoing">
          <textarea id="keepDoing" formControlName="keepDoing" class="form-control" [readonly]="checkingField.keepDoing"
            (blur)="handleTextareaBlur('keepDoing')"></textarea>
          <div class="textarea-overlay" *ngIf="checkingField.keepDoing" aria-live="assertive">
            <div class="textarea-overlay__ai-spinner" aria-hidden="true">
              <span class="orb"></span>
              <span class="track track--one"></span>
              <span class="track track--two"></span>
              <span class="glow"></span>
            </div>
            <p class="textarea-overlay__title">Nossa IA está revisando sua mensagem...</p>
            <p class="textarea-overlay__subtitle">
              {{ checkingMessage.keepDoing || checkingText }}
            </p>
          </div>
        </div>
        <small>No que é bom e deve continuar fazendo.</small>

        <div class="feedback-suggestion-success mt-1" *ngIf="suggestionApplied.keepDoing">
          <div class="feedback-suggestion-success__message">
            <i data-feather="check-circle" class="mr-50"></i>
            <span>Sugestão aplicada com sucesso</span>
          </div>
          <button class="btn btn-sm btn-success" type="button" (click)="undoSuggestion('keepDoing')">
            Desfazer
          </button>
        </div>

        <div class="feedback-suggestion-card mt-1" *ngIf="suggestionMessage.keepDoing && !suggestionApplied.keepDoing">
          <div class="feedback-suggestion-card__title">
            <img src="assets/images/icons/sparkle.svg" alt="sparkle" class="mr-50" />
            <span>Sugestão</span>
          </div>
          <p class="feedback-suggestion-card__text">{{ suggestionMessage.keepDoing }}</p>
          <div class="d-flex justify-content-end">
            <button class="btn btn-sm btn-outline-primary" type="button" (click)="applySuggestion('keepDoing')">
              Usar sugestão
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-2 px-2">
        <label class="form-control-label" for="stopDoing">Parar de fazer</label>
        <div class="textarea-wrapper" [class.is-checking]="checkingField.stopDoing">
          <textarea id="stopDoing" formControlName="stopDoing" class="form-control" [readonly]="checkingField.stopDoing"
            (blur)="handleTextareaBlur('stopDoing')"></textarea>
          <div class="textarea-overlay" *ngIf="checkingField.stopDoing" aria-live="assertive">
            <div class="textarea-overlay__ai-spinner" aria-hidden="true">
              <span class="orb"></span>
              <span class="track track--one"></span>
              <span class="track track--two"></span>
              <span class="glow"></span>
            </div>
            <p class="textarea-overlay__title">Nossa IA está revisando sua mensagem...</p>
            <p class="textarea-overlay__subtitle">
              {{ checkingMessage.stopDoing || checkingText }}
            </p>
          </div>
        </div>
        <small>O que mais precisa da sua atenção.</small>

        <div class="feedback-suggestion-success mt-1" *ngIf="suggestionApplied.stopDoing">
          <div class="feedback-suggestion-success__message">
            <i data-feather="check-circle" class="mr-50"></i>
            <span>Sugestão aplicada com sucesso</span>
          </div>
          <button class="btn btn-sm btn-success" type="button" (click)="undoSuggestion('stopDoing')">
            Desfazer
          </button>
        </div>

        <div class="feedback-suggestion-card mt-1" *ngIf="suggestionMessage.stopDoing && !suggestionApplied.stopDoing">
          <div class="feedback-suggestion-card__title">
            <img src="assets/images/icons/sparkle.svg" alt="sparkle" class="mr-50" />
            <span>Sugestão</span>
          </div>
          <p class="feedback-suggestion-card__text">{{ suggestionMessage.stopDoing }}</p>
          <div class="d-flex justify-content-end">
            <button class="btn btn-sm btn-outline-primary" type="button" (click)="applySuggestion('stopDoing')">
              Usar sugestão
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-2 px-2">
        <label class="form-control-label" for="startDoing">Começar a fazer</label>
        <div class="textarea-wrapper" [class.is-checking]="checkingField.startDoing">
          <textarea id="startDoing" formControlName="startDoing" class="form-control"
            [readonly]="checkingField.startDoing" (blur)="handleTextareaBlur('startDoing')"></textarea>
          <div class="textarea-overlay" *ngIf="checkingField.startDoing" aria-live="assertive">
            <div class="textarea-overlay__ai-spinner" aria-hidden="true">
              <span class="orb"></span>
              <span class="track track--one"></span>
              <span class="track track--two"></span>
              <span class="glow"></span>
            </div>
            <p class="textarea-overlay__title">Nossa IA está revisando sua mensagem...</p>
            <p class="textarea-overlay__subtitle">
              {{ checkingMessage.startDoing || checkingText }}
            </p>
          </div>
        </div>
        <small>Quais ações você precisa colocar em prática.</small>

        <div class="feedback-suggestion-success mt-1" *ngIf="suggestionApplied.startDoing">
          <div class="feedback-suggestion-success__message">
            <i data-feather="check-circle" class="mr-50"></i>
            <span>Sugestão aplicada com sucesso</span>
          </div>
          <button class="btn btn-sm btn-success" type="button" (click)="undoSuggestion('startDoing')">
            Desfazer
          </button>
        </div>

        <div class="feedback-suggestion-card mt-1" *ngIf="suggestionMessage.startDoing && !suggestionApplied.startDoing">
          <div class="feedback-suggestion-card__title">
            <img src="assets/images/icons/sparkle.svg" alt="sparkle" class="mr-50" />
            <span>Sugestão</span>
          </div>
          <p class="feedback-suggestion-card__text">{{ suggestionMessage.startDoing }}</p>
          <div class="d-flex justify-content-end">
            <button class="btn btn-sm btn-outline-primary" type="button" (click)="applySuggestion('startDoing')">
              Usar sugestão
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 mb-2">
        <div class="custom-control custom-switch" *ngIf="feedbackVisibilityMode === visibilityMode.ManagerDecides">
          <input type="checkbox" class="custom-control-input" id="customSwitch11" formControlName="showToEmployee" />
          <label class="form-control-label custom-control-label" for="customSwitch11">
            <span class="switch-icon-left"><i data-feather="check"></i></span>
            <span class="switch-icon-right"><i data-feather="x"></i></span>
          </label>
          Deixar visível ao colaborador?
        </div>
      </div>
    </div>

    <div class="row mt-3 d-flex gap-2 justify-content-end pr-2">
      <button class="btn btn-secondary" type="button" (click)="handleCancel()">Cancelar</button>
      <button class="btn btn-primary" type="submit" [disabled]="!canSubmit">
        Enviar <i data-feather="send" class="me-1"></i>
      </button>
    </div>
  </form>

  <div *ngIf="mode === FeedbackFormMode.View" class="px-2 py-2">
    <p><strong>Enviado por:</strong></p>
    <div class="mb-2">
      <p class="m-0 font-weight-bolder">{{ feedbackView.employeeManagerName }}</p>
      <p class="text-muted m-0 small">{{ feedbackView.employeeManagerJobTitle }}</p>
    </div>
    <p><strong>Data:</strong> {{ feedbackView.creationDate | date: 'dd/MM/yyyy' }}</p>
    <hr class="mt-0 mb-2" />

    <div class="mb-2" *ngIf="feedbackView.keepDoing">
      <p class="font-weight-bold m-0">Continuar fazendo</p>
      <div class="border border-light rounded p-2 my-1">
        <p class="m-0">{{ feedbackView.keepDoing }}</p>
      </div>
    </div>

    <div class="mb-2" *ngIf="feedbackView.stopDoing">
      <p class="font-weight-bold m-0">Parar de fazer</p>
      <div class="border border-light rounded p-2 my-1">
        <p class="m-0">{{ feedbackView.stopDoing }}</p>
      </div>
    </div>

    <div class="mb-2" *ngIf="feedbackView.startDoing">
      <p class="font-weight-bold m-0">Começar a fazer</p>
      <div class="border border-light rounded p-2 my-1">
        <p class="m-0">{{ feedbackView.startDoing }}</p>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <button class="btn btn-secondary" (click)="handleCancel()">Fechar</button>
    </div>
  </div>
</app-shared-drawer>